// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.91.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.91.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#venusUI {
  /**
   * Usage:
   *    p { .withBorder() } => p { border: @box-border }
   *    p { .withBorder(@border: @border) } => p { border: @border }
   *    p { .withBorder(true; @border) } => p { border: @border }
   *    p { .withBorder(left top) } => p { border-left: @box-border; border-top: @box-border; }
   *    p { .withBorder(left top; @border) } => p { border-left: @border; border-top: @border; }
   */
}
.skeleton-loader {
  display: inline-block;
  background: var(--color-skeleton-loader-background);
  color: transparent;
  position: relative;
  overflow: hidden;
  width: 70%;
  border-radius: 4px;
}
.skeleton-loader::before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  width: 50%;
  background: linear-gradient(to right, var(--color-skeleton-loader-background) 25%, var(--color-skeleton-loader-background-accent) 50%, var(--color-skeleton-loader-background) 100%);
  animation-name: gradient-animation;
  animation-duration: 2s;
  animation-iteration-count: infinite;
  filter: blur(3px);
}
@keyframes gradient-animation {
  from {
    left: -50%;
  }
  to {
    left: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/neptune-app/libs/shared/venus/ui/less/mixins/decorators.less","webpack://./src/neptune-app/libs/shared/common/ui/skeleton-loader/SkeletonLoader.less"],"names":[],"mappings":"AAEA;ECDE;;;;;;;IAOE;AACJ;AAPA;EAIE,qBAAA;EAEA,mDAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,UAAA;EDaE,kBAAA;ACPJ;AAHE;EACE,WAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;EACA,YAAA;EACA,UAAA;EAEA,oLAAA;EACA,kCAAA;EACA,sBAAA;EACA,mCAAA;EACA,iBAAA;AAIJ;AADE;EACE;IACE,UAAA;EAGJ;EADE;IACE,UAAA;EAGJ;AACF","sourcesContent":["@import \"../variables.less\";\n\n#venusUI {\n\n  /**\n   * Usage:\n   *    p { .withBorder() } => p { border: @box-border }\n   *    p { .withBorder(@border: @border) } => p { border: @border }\n   *    p { .withBorder(true; @border) } => p { border: @border }\n   *    p { .withBorder(left top) } => p { border-left: @box-border; border-top: @box-border; }\n   *    p { .withBorder(left top; @border) } => p { border-left: @border; border-top: @border; }\n   */\n  .withBorder(@sides: true; @border: @box-border ) {\n    .setBorder(@side) when (@side) {\n      border: @border;\n    }\n    .setBorder(@side) when (@side = left), (@side = right), (@side = top), (@side = bottom){\n      border-@{side}: @border;\n    }\n    each(@sides, {\n      .setBorder(@value);\n    });\n  }\n\n  .withBorderRadius(@radius: @box-border-radius) {\n    border-radius: @radius;\n  }\n\n  .withShadow(@shadow: @box-shadow) {\n    box-shadow: @shadow;\n  }\n}\n","@import \"~venus\";\n\n.skeleton-loader  {\n  @color-bg: var(--color-skeleton-loader-background);\n  @color-ac: var(--color-skeleton-loader-background-accent);\n\n  display: inline-block;\n\n  background: @color-bg;\n  color: transparent;\n  position: relative;\n  overflow: hidden;\n  width: 70%;\n  #venusUI.withBorderRadius();\n\n  &::before {\n    content: \"\";\n    position: absolute;\n    left: 0;\n    top: 0;\n    height: 100%;\n    width: 50%;\n\n    background: linear-gradient(to right, @color-bg 25%, @color-ac 50%, @color-bg 100%);\n    animation-name: gradient-animation;\n    animation-duration: 2s;\n    animation-iteration-count: infinite;\n    filter: blur(3px);\n  }\n\n  @keyframes gradient-animation {\n    from {\n      left: -50%;\n    }\n    to {\n      left: 100%;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
